import { reaction } from 'mobx';
import { createContext, useContext, useSyncExternalStore } from 'react';

import { settingsStore } from '@/stores/settings.store';

const subscribe = (onChange: () => void) =>
  reaction(() => settingsStore.timeFormat, onChange);

const readTimeFormat = () => settingsStore.timeFormat;

// A clock to show instead of the saved setting, for a preview that must not change it.
// Undefined means no preview, so the saved setting applies
export const TimeFormatPreviewContext = createContext<
  boolean | null | undefined
>(undefined);

// The app's Time Format setting: true is 12-hour, false is 24-hour, null the locale's
// clock. Registry components are called as plain functions, not rendered as their own
// components, so they cannot be `observer`s; this subscribes instead
export function useTimeFormat(): boolean | null {
  const previewTimeFormat = useContext(TimeFormatPreviewContext);
  const savedTimeFormat = useSyncExternalStore(subscribe, readTimeFormat);
  return previewTimeFormat === undefined ? savedTimeFormat : previewTimeFormat;
}
